import './App.css';
import Profile from "./components/utilities/Profile/Profile.jsx";



function Profilepage() {
  return (
    <div>
      
      <Profile/>
      
    </div>
  );
}

export default Profilepage;